import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import { mapState, mapActions } from 'vuex'

Vue.config.productionTip = false

//* Allow debugging for all environments
Vue.config.devtools = true
Vue.config.debug = true
Vue.config.silent = false

new Vue({
  router,
  store,
  vuetify,
  computed: {
    ...mapState(["settings"])
  },
  data() {
    return {
      validationRules: {
        numeric: value => {
          if (value == null || value === "" || value === 0) return true;
          if (!value) return 'Must be numeric';
          if (isNaN(value)) return 'Must be numeric';
          return true;
        },
        numericSelect: value => {
          if (!value) return 'Required';
          if (isNaN(value)) 'Required';
          return true;
        },
        requiredMultiselect: value => {
          if ( !value ) return "Required";
          if (value.length > 0) return true;
          else return "Required";
        },
        required: value => {
          if (value === 0) return true;
          if (!value) return 'Required';
          if (typeof value === 'string' && value.trim()) return true;
          if (isNaN(value)) return 'Required';
          return true;
        },
        boolean: value => {
          if (value == null) return 'Required';
          if (typeof value === 'boolean') return true;
          return 'Required';
        },
        greaterThanZero: value => {
          let theNum = parseFloat(value);
          if (Object.is(theNum, NaN)) return true;
          if (theNum > 0) return true;
          return 'Must be greater than 0';
        },
        noSpacesAllowed: value => {
          if (!value) return true;
          if (value.indexOf(" ") == -1) return true;
          return 'Spaces not allowed';
        }
      }
    }
  },
  render: h => h(App),
  async created() {
    try {
      this.exitIfAppAlreadyRunning();

      window.addEventListener("error", this.handleUncaughtError);
      window.addEventListener("online", this.onlineStatusChanged);
      window.addEventListener("offline", this.onlineStatusChanged);

      await this.initializeStore();

      this.$vuetify.theme.dark = this.settings.isDarkMode;
      this.$mount("#app");
    } catch (error) {
      const errorMsg = `Store Initialization failed. ${error}`;
      alert(errorMsg);
      this.$vuetify.theme.dark = this.settings.isDarkMode;
      this.$mount("#app");
    }
  },
  errorCaptured(error) {
    this.showNoticeError(error.message);
  },
  beforeDestroyed() {
    window.removeEventListener("error", this.handleUncaughtError);
    window.removeEventListener("online", this.onlineStatusChanged);
    window.removeEventListener("offline", this.onlineStatusChanged);
  },
  methods: {
    ...mapActions(["setOnlineStatusInStore", "initializeStore"]),
    exitIfAppAlreadyRunning() {
      const bc = new BroadcastChannel("Egg-Picker-Web");
      const amITheFirst = "`Am I the first?";
      const youAreNotTheFirst = `You are not the first.`;
      bc.onmessage = (event) => {
        if (event.data === amITheFirst) {
          bc.postMessage(`You are not the first.`);
        }
        if (event.data === youAreNotTheFirst) {
          var newHTML = document.open("text/html", "replace");
          var html = `<html>
          <body>
          <div class="hero">
            <div class="title">
              <h1>
                Cobb Egg Picker
              </h1>
              <div>
                <h3>
                  Application is already running. Please exit.
                </h3>
              <div>
            </div>
          </div>
          <style>
            h1 {
              color: #FFFFFF;
              caret-color: #FFFFFF;
              font-size: 3.75rem;
              font-weight: 300;
              font-family: "Roboto", sans-serif;
            }
            h3 {
              background-color: #dc2c2c;
              margin: 20px;
              padding: 20px;
              font-family: "Roboto", sans-serif;
              color: white;
            }
            body {
              background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.8)), 
                 url('${require("@/assets/img/favicon-742x742.png")}');
              background-repeat: no-repeat;
              background-position:center;
            }
            .title {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              text-align: center;
            }
            .hero h1 {
               text-shadow: 5px 3px 5px black;
            }
          </style>
          </body>
          </html>`;

          newHTML.write(html);
          newHTML.close();
        }
      };
      bc.postMessage(amITheFirst);
    },
    handleUncaughtError(event) {
      this.showNoticeError(event.message);
      return true;
    },
    onlineStatusChanged() {
      this.setOnlineStatusInStore(navigator.onLine);
    }, 
    showNoticeError(msg, closeCallback) {
      if (typeof msg != "string") msg += "";
      window.dispatchEvent(new CustomEvent('cep-show-notice', {
        detail:{text: msg, on: true, noticeType: 'error', closeCallback: closeCallback}
      }));
      if (this.settings.isErrorSoundEnabled) {
        const audio = new Audio('sound/error-beep.mp3');
        audio.play();
      }
    },
    showNoticeWarning(msg) {
      if (typeof msg != "string") msg += "";
      window.dispatchEvent(new CustomEvent('cep-show-notice', {
        detail:{text: msg, on: true, noticeType: 'warning'}
      }));
    },
    showNoticeInfo(text) {
      window.dispatchEvent(new CustomEvent('cep-show-notice', {
        detail: {text: text, on: true, noticeType: 'info'}
      }));
    },
    showNoticeSuccess(text) {
      window.dispatchEvent(new CustomEvent('cep-show-notice', {
          detail: {text: text, on: true, noticeType: 'success'}
      }));
    },
    waitAsync(ms) {
      return new Promise(resolve => {
        setTimeout(resolve, ms);
      });
    }
  }
})